"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (start, end) {
    var diff = end.getTime() - start.getTime();

    var days = Math.floor(diff / factors.days);
    diff -= days * factors.days;
    var d = days > 0 ? days + "d" : "";

    var hours = Math.floor(diff / factors.hours);
    diff -= hours * factors.hours;
    var h = hours > 0 ? hours + "h" : "";

    var minutes = Math.floor(diff / factors.minutes);
    diff -= minutes * factors.minutes;
    var m = minutes > 0 ? minutes + "m" : "";

    var seconds = Math.floor(diff / factors.seconds);
    diff -= seconds * factors.seconds;
    var s = seconds > 0 ? seconds + "s" : "";

    var ms = diff > 0 ? diff + "ms" : "";

    var fragments = [d, h, m, s, ms].filter(function (i) {
        return i.length > 0;
    });
    if (fragments.length === 0) {
        return "0";
    }

    return fragments.join(" ");
};

var factors = {
    seconds: 1000,
    minutes: 1000 * 60,
    hours: 1000 * 60 * 60,
    days: 1000 * 60 * 60 * 24
};
//# sourceMappingURL=index.js.map